import { IUserAuth } from './../utilities/interfaces';
import { IUserData } from '../utilities/interfaces';
import { State } from './../state/state';

export class UserDataState extends State<IUserAuth> {

}
